
        <qb-alert [alert]="currentAlert" (onAlertClose)="handleAlertClosed($event)"></qb-alert>
    